import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppRow',{attrs:{"permission":"UNDEFINED"}},[_c(VCol,[_c(VAlert,{attrs:{"outlined":"","type":"error"}},[_vm._v(" Этот раздел отключен! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }